import React from 'react';

const HideUsersCard = ({ hideUsers }) => {
    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Danh sách users hide với UV</h3>
            </div>
            <div className='card-body table-responsive p-0' style={{minHeight: 200}}>
                <table
                    className='table table-hover table-bordered text-nowrap text-center'
                >
                    <thead>
                    <tr>
                        <th>No.</th>
                        <th>User email</th>
                    </tr>
                    </thead>
                    <tbody>
                    {hideUsers.map((user, index) => {
                        return <tr key={`hide_user_${index}`}>
                            <td>{index + 1}</td>
                            <td>{user.email}</td>
                        </tr>
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default HideUsersCard;


